export function addCurrent(chatbot) {
  return {
    type: 'ADD_CURRENT',
    chatbot,
  }
}
